export enum STAGE {
  FACE_DISPLACED = "face_displaced",
  FACE_PITCH_ANGLE_DEVIATION = "face_pitch_angle_deviation",
  FACE_ROLL_ANGLE_DEVIATION = "face_roll_angle_deviation",
  FACE_YAW_ANGLE_DEVIATION = "face_yaw_angle_deviation",
  FACE_DISTANCE_CLOSE = "face_distance_close",
  FACE_DISTANCE_FAR = "face_distance_far",
  LIGHTING_INSUFFICIENT = "lighting_insufficient",
  LIGHTING_EXCESSIVE = "lighting_excessive",
  LIGHTING_ANGLE_DEVIATION = "lighting_angle_deviation",
  CAPTURING_FRONT = "capturing_front",
  CAPTURING_LEFT = "capturing_left",
  CAPTURING_RIGHT = "capturing_right",
  CAPTURING_DONE = "capturing_done",
  ROTATING_LEFT = "rotating_left",
  ROTATING_RIGHT = "rotating_right",
}

const {
  CAPTURING_FRONT,
  ROTATING_LEFT,
  ROTATING_RIGHT,
  CAPTURING_LEFT,
  CAPTURING_RIGHT,
  CAPTURING_DONE,
  ...QUALITY_PROBLEM_STAGE
} = STAGE

export const Stages = [
  ...Object.values(QUALITY_PROBLEM_STAGE),
  CAPTURING_FRONT,
  ROTATING_LEFT,
  CAPTURING_LEFT,
  ROTATING_RIGHT,
  CAPTURING_RIGHT,
  CAPTURING_DONE,
]

// TODO: Move common stages to a shared module
export const ANGLE_DEVIATION_STAGES = [
  STAGE.FACE_ROLL_ANGLE_DEVIATION,
  STAGE.FACE_YAW_ANGLE_DEVIATION,
  STAGE.FACE_PITCH_ANGLE_DEVIATION,
] as const
